import { Redirect, useLocalSearchParams } from 'expo-router';

/**
 * Legacy path → `/universal-space` (bookmarks / old CMS links).
 * Preserves `?id=` and other query params.
 */
export default function BloomUniversalSpaceRedirect() {
  const params = useLocalSearchParams<Record<string, string | string[]>>();
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined) {
      continue;
    }
    if (Array.isArray(value)) {
      for (const item of value) {
        search.append(key, item);
      }
    } else {
      search.set(key, value);
    }
  }
  const query = search.toString();
  const href = query.length > 0 ? `/universal-space?${query}` : '/universal-space';
  return <Redirect href={href as never} />;
}
